import * as React from 'react';
import { CloseIcon, SearchIcon } from '../../../assets/icons';
import { GroupButton } from '../GroupButtons';
import { SearchInput } from '../SearchInput';
import { DropdownComponent, InputComponent } from '../../core/Forms';
import { FILTER_LIST } from '../../../constants';
import Chip from '../Chip';
import { Filter } from '../../../@types/inventory';
type FilterCallback = (filter: Filter) => void;

interface HeadProps {
  buttons: Array<{
    text: string;
    icon: any;
    onClick?: () => void;
    href?: string;
  }>;
  handleSearch?: (text: string) => void;
  handleFilter?: FilterCallback;
  filter?: Filter;
  handleSort?: (text: string) => void;
  handleSearchSelect?: (item: any) => void;
  isSearching?: boolean;
  searchResult: any[];
  searchDisplayKey: string;
  searchPlaceHolder: string;
}
const MobileHead: React.FC<HeadProps> = (props) => {
  const [text, setText] = React.useState('');
  const [selectedValue, setSelectedValue] = React.useState(' Recent');
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const dropDownArray = FILTER_LIST;
  const [isSearching, setIsSearching] = React.useState(true);

  const handleSearch = async (text: string) => {
    if (!text || text.length < 2) return;

    try {
      setIsSearching(true);
      await props.handleSearch?.(text);
    } catch (error) {
      console.error('Error occurred during search:', error);
    } finally {
      setIsSearching(false);
    }
  };

  const handleDropDownChange = (value: string) => {
    props.handleSort ? props.handleSort(selectedValue) : null;
  };

  const handleChipClose = (chipKey: keyof Filter) => {
     if (props?.filter) {
       let newFilter = { ...props?.filter };
       if (chipKey in newFilter) {
         if (typeof newFilter[chipKey] === 'string') {
           (newFilter[chipKey] as string) = '';
         }
       }
       props.handleFilter ? props.handleFilter(newFilter as Filter) : undefined;
       console.log('Filtering with filter:', props.handleFilter);
     }
  };

  const renderFilterChip = () => {
    const chips = [];
    const filterLabels = {
      status: 'Status',
      isReoccurring: { true: 'Reoccurring', false: 'One-time' },
      billable: { true: 'Billable', false: 'Not Billable' },
      paymentMethod: 'Payment Method',
    };

 
    if (props.filter) {
      for (const key in filterLabels) {
        const filterKey = key as keyof Filter;
        if (filterKey in props.filter && props.filter[filterKey] !== null && props.filter[filterKey] !== '') {
          const label = props.filter[filterKey];
          chips.push(<Chip key={filterKey} label={label} clearAction={() => handleChipClose(filterKey)} />);
        }
      }
    }

    return chips;
  };

  return (
    <> 
      <div className=' md:hidden'>
      <div className='flex md:hidden flex-row-reverse gap-[20px]  justify-center items-center lg:hidden'>
       <div className='mt-[5px] text-[22px]'>
         <GroupButton buttons={props.buttons} />
          </div>
          <div className="w-[228px] ">
            <SearchInput
              placeholder={props.searchPlaceHolder}
              displayKey={props.searchDisplayKey}
              isLoading={isSearching}
              value={text}
              onSelect={props.handleSearchSelect}
              handleChangeText={handleSearch}
              clearIcon={CloseIcon}
              icon={<SearchIcon />} 
              data={props.searchResult}
               emptyMessage={'This Item is not found'}
               dropdownClassName="w-[228px] ml-[0.1em]"
              dropdownStyle={{
                maxHeight: '800px',
                overflowY: 'auto',
              }}
              classNames="w-[228px] 412:ml-[-0.2em] 375:ml-[0.2em] 360:ml-[-0.2em] 414:ml-[-0.2em] ml-[-2.3em] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px] h-[39.77px] rounded p-2 mt-[5px] focus:outline-none focus:shadow-outline appearance-none lg:focus:ring-0 leading-normal"
            />
          </div>
       </div>
       <div className="">
          <DropdownComponent
            options={dropDownArray}
            value={selectedValue}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            isSubmitted={isSubmitted}
            onChange={handleDropDownChange}
            dropdownClassName="w-[348px] py-2 mt-[1em] rounded py-1 focus:ring-0 pointer-events bg-white flex justify-center"
            iconClassName=" mr-[1em] mt-[0.3em] "
          />
        </div>
      </div>

      <div className="flex">{renderFilterChip()}</div>
    </>
  );
};

export { MobileHead };
